import {
  fetchDetail,
  fetchDelete,
  fetchCreate,
  fetchEdit,
} from '@/api/code';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch(context, id) {
    const { commit } = context;
    commit('setIsLoading', true);
    return fetchDetail(id)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve code',
          () => commit('reset')
        )
      )
    ;
  },
  remove({ state, commit, dispatch }, id = null) {
    commit('setIsLoading', true);
    if (!id) {
      id = state.item.id;
    }
    return fetchDelete(id)
      .then(res => AuthResponse.validateDelete(res, dispatch))
      .catch(e => Notifications.error(
        e.toString() || `Failed to delete code: ${id}`,
        () => commit('reset')
        )
      )
      ;
  },
  save({ state, dispatch }) {
    return state.item.id ? dispatch('update') : dispatch('create');
  },
  create(context) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    return fetchCreate(state.item)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
        e.toString() || 'Failed to create code',
        () => commit('reset')
        )
      )
      ;
  },
  update(context) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    return fetchEdit(state.item)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
        e.toString() || `Failed to save code: ${state.item.id}`,
        () => commit('reset')
        )
      )
      ;
  },
};
